/* tslint:disable */
/* eslint-disable */
/**
 * K·HERO
 * K·HERO API documentation
 *
 * OpenAPI spec version: 1.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import { JoinEntityDto } from './join-entity-dto';
import { SessionReferencesAssignmentDto } from './session-references-assignment-dto';
import { SessionReferencesCountsDto } from './session-references-counts-dto';
 /**
 *
 *
 * @export
 * @interface SessionReferencesDto
 */
export interface SessionReferencesDto {

    /**
     * The catalog session these references point to
     *
     * @type {JoinEntityDto}
     * @memberof SessionReferencesDto
     */
    session: JoinEntityDto;

    /**
     * How many therapies reference this session. Above 1, an edit reaches more than the therapy the practitioner is looking at.
     *
     * @type {number}
     * @memberof SessionReferencesDto
     * @example 2
     */
    therapies: number;

    /**
     * References an edit could still realign: events not yet started
     *
     * @type {SessionReferencesCountsDto}
     * @memberof SessionReferencesDto
     */
    updatable: SessionReferencesCountsDto;

    /**
     * What would be left untouched: events already started or resolved. Shown so the practitioner understands the edit is not retroactive.
     *
     * @type {SessionReferencesCountsDto}
     * @memberof SessionReferencesDto
     */
    frozen: SessionReferencesCountsDto;

    /**
     * How many OTHER practitioners of the same client own affected assignments. Zero means the edit stays within the caller’s own work.
     *
     * @type {number}
     * @memberof SessionReferencesDto
     * @example 1
     */
    otherPractitioners: number;

    /**
     * Whether rebuilding the events would also change their exercise weights, because the resolved chain no longer matches what was frozen at assign time — typically a clinic-level weight edited since. Flagged so the practitioner is not surprised by a change they did not make here.
     *
     * @type {boolean}
     * @memberof SessionReferencesDto
     */
    weightsWouldChange: boolean;

    /**
     * The affected assignments, most imminent first. Only those with events that would be rewritten appear here.
     *
     * @type {Array<SessionReferencesAssignmentDto>}
     * @memberof SessionReferencesDto
     */
    assignments: Array<SessionReferencesAssignmentDto>;
}
